import { FC } from 'react';
import { MessageDataTitle } from '@/types/types';
import { Button, ButtonProps, LoadingOverlay } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useTypedSelector } from '@/store/hooks';
import {
	buildConfigurationUrl,
	serializeCreatorState,
} from '@/utils/creatorUtils';
import { ProjectRenderer } from '@/renderer/ProjectRenderer';
import ProjectApi from '@/api/ProjectApi';
import { useContent } from '@/providers/ContentProvider';

const renderer = ProjectRenderer.getInstance();

const baseSlug = 'contactFormButton.';

interface Props extends ButtonProps {}

export const ContactFormButton: FC<Props> = (props) => {
	const state = useTypedSelector((state) => state.creator);
	const { project, storeId } = state;

	const { getContent } = useContent();

	const updateProjectMutation = useMutation({
		mutationFn: ProjectApi.update,
		onSuccess: () => {
			getXLSXMutation.mutate({
				id: project.id,
				type: 'xlsx',
			});
		},
	});

	const getXLSXMutation = useMutation({
		mutationFn: ProjectApi.exportFile,
		onSuccess: (blob) => {
			const configurationUrl = buildConfigurationUrl(storeId, project.id);

			window!.top!.postMessage(
				{
					title: MessageDataTitle.CONTACT_FORM,
					payload: {
						configuratorName: 'sofa_module',
						configurationUrl,
						configurationFile: blob,
					},
				},
				'*'
			);
		},
	});

	const handleContactForm = () => {
		updateProjectMutation.mutate({
			id: project.id,
			serializedConfiguration: serializeCreatorState(state, renderer.export()),
		});
	};

	const isPending =
		updateProjectMutation.isPending || getXLSXMutation.isPending;

	return (
		<>
			<LoadingOverlay visible={isPending} />
			<Button {...props} onClick={handleContactForm} disabled={isPending}>
				{getContent(`${baseSlug}label`)}
			</Button>
		</>
	);
};
